export function withBackdropCloseGuard({
  onClose,
  enabled = true,
}: {
  onClose: (event?: object, reason?: string) => void;
  enabled?: boolean;
}): (event: object, reason: string) => void {
  return (event: object, reason: string) => {
    if (enabled && reason && reason === "backdropClick") return;
    onClose(event, reason);
  };
}
